import { UserContext, GeneralContext } from 'context'
import useAuth from 'hooks/useAuth'
import { useContext, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { hideMenu, logo, logoMenu, logoSmall } from 'assets/Icons'
import { useStorage } from 'hooks'
import { Icon } from 'assets/index'
import { optionsLevels, hasAccess } from 'helper/utils'
import { Menu } from './style'
import Button from './ButtonMenu'

export default function MenuComponent() {
  const { extended, setExtended } = useContext(UserContext)
  const auth = useAuth()
  const location = useLocation()
  const [user] = useStorage('User')

  const handleLogout = () => {
    auth.signout(() => console.log('logout'))
  }

  const handleExtendMenu = () => {
    setExtended((oldValue) => !oldValue)
  }

  useEffect(() => {
    if (!optionsLevels[user.level]) return
    setExtended(false)
  }, [])

  return (
    <Menu extended={extended}>
      <div>
        <button
          type="button"
          className="extendButton"
          onClick={handleExtendMenu}
          onKeyDown={handleExtendMenu}
        >
          <img
            src={Icon('chevron_left.svg')}
            alt="extend menu"
            className="icon"
          />
        </button>

        <div className="logo-container">
          <img
            className="logo"
            src={extended ? logoMenu : logoMenu}
            alt="card icon"
          />
        </div>
        <Button
          renderBorder
          extended={extended}
          icon={Icon('dashboard.svg')}
          name="dashboard"
          active={/dashboard/i.test(location.pathname)}
          to="dashboard"
          // id="dashboard" id nao esta pegando no botao do menu
          disabled={
            !hasAccess('dashboard')
            // ![
            //   'OWNER',
            //   'DIRECTOR',
            //   'GESTOR',
            //   'SPECIALIST',
            //   'FINANCIAL',
            //   'LEGAL',
            //   'SPECGESTOR',
            // ].includes(optionsLevels[user.level])
          }
        >
          Dashboard
        </Button>
        <Button
          extended={extended}
          icon={Icon('profile.svg')}
          name="clientes"
          active={/clientes/i.test(location.pathname)}
          disabled={
            !hasAccess('clients')
            // ![
            //   'OWNER',
            //   'DIRECTOR',
            //   'GESTOR',
            //   'SPECIALIST',
            //   'FINANCIAL',
            //   'LEGAL',
            //   'SPECGESTOR',
            // ].includes(optionsLevels[user.level])
          }
          to="clientes"
        >
          Gestão de clientes
        </Button>
        <Button
          extended={extended}
          icon={Icon('building.svg')}
          name="produtos"
          active={/produtos/i.test(location.pathname)}
          disabled={
            !hasAccess('products')
            // ![
            //   'OWNER',
            //   'DIRECTOR',
            //   'GESTOR',
            //   // 'SPECIALIST',
            //   'FINANCIAL',
            //   'SPECGESTOR',
            // ].includes(optionsLevels[user.level])
          }
          to="produtos"
        >
          Gestão de produtos
        </Button>
        <Button
          extended={extended}
          icon={Icon('users.svg')}
          name="colaboradores"
          active={/colaboradores/i.test(location.pathname)}
          disabled={
            // !['OWNER', 'RH'].includes(optionsLevels[user.level])
            !hasAccess('gestors')
          }
          to="colaboradores"
        >
          Gestão de Colaboradores
        </Button>
        <Button
          extended={extended}
          icon={Icon('trophy.svg')}
          name="financeiro"
          active={/financeiro/i.test(location.pathname)}
          disabled={
            !hasAccess('financial')
            // !['OWNER', 'FINANCIAL'].includes(optionsLevels[user.level])
          }
          to="financeiro"
        >
          Financeiro
        </Button>
        {/* 
        <Button
          extended={extended}
          icon={Icon('cast_banner.svg')}
          name="banner"
          active={/banner/i.test(location.pathname)}
          to="banner"
        >
          Banner
        </Button> 
      */}
      </div>

      <Button
        logoutButton
        extended={extended}
        icon={Icon('logout.svg')}
        name="Logout"
        onClick={handleLogout}
        to="login"
      >
        Log out
      </Button>
    </Menu>
  )
}
